module.exports = __webpack_public_path__ + "static/logo-kar-tel-beeline-kz-a18026ba6836b2071386217a7c2576f7.png";